// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './store'


import ElementUI from 'element-ui';
import 'assets/theme/index.css';

import api from '@/request/api'
import * as filters from './filters';

import VueDOMPurifyHTML from 'vue-dompurify-html';
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhLocale from 'assets/languages/zh'
import enLocale from 'assets/languages/en'
import koLocale from 'assets/languages/ko'


import Share from 'vue-social-share'

/*ie兼容*/
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;
import promise from 'es6-promise'
promise.polyfill();

Vue.use(VueDOMPurifyHTML)
Vue.use(Share)
import router from './router'

// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(VueI18n)
Vue.use(ElementUI)


import oninputPolyfill from 'ie9-oninput-polyfill'//兼容ie9 不能识别input回退删除等事件变化
Vue.use(oninputPolyfill);


import supportIE from "./utils/supportPlaceholder"; //ie9 placeholder兼容指令
Vue.use(supportIE);

const i18n = new VueI18n({
  locale: 'zh', // 定义默认语言为中文 
  messages: {
    'zh': zhLocale,
    'en': enLocale,
    'ko': koLocale
  }
});
if (localStorage.getItem('langLocale')) {
  i18n.locale = localStorage.getItem('langLocale');
}
ElementLocale.i18n((key, value) => i18n.t(key, value));
Vue.config.productionTip = false



Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)






function doSeo() {
  const keywords = "韩国签证,韩国签证网,韩国签证服务中心网，韩国签证服务中心，线上签证中心，韩国线上签证中心，大韩民国官方线上签证中心，韩国签证申请中心,韩国线上签证官方授权指定机构,线上签证服务";
  const description = "韩国签证申请中心是由国家移民总局授权，在中国境内唯一官方办理与预约签证相关业务的服务性机构，也是唯一线上申请服务平台。.为韩国签证申请人提供专业的签证咨询、签证受理、韩国签证办理流程、签证所需材料、网约优先服务、线上签证服务、线下服务、签证费用、签证类型、查询预约等签证办理攻略，让您轻松办理韩国个人旅游、商务、探亲、工作、移民、留学等签证服务."
  let head = document.getElementsByTagName('head');
  let meta1 = document.createElement('meta');
  let meta2 = document.createElement('meta');
  meta1.name = "keywords";
  meta1.content = keywords
  meta2.name = "description";
  meta2.content = description;
  head[0].appendChild(meta1)
  head[0].appendChild(meta2)
}
doSeo()

router.beforeEach((to, from, next) => {
  console.log('to:', to);
  if (to.meta.title) {
    let pageTitle = i18n.t(to.meta.title)
    document.title = pageTitle;
  }
  // if (to.path === '/visa/choiceVisaType') {
  //   if (!to.query || !to.query.centerId) {
  //     toLogin()
  //   }
  // }
  // if (to.path !== '/') {
  //   if (!store.state.isLogin) {
  //     toLogin()
  //   }
  // }
  next()
})
const toLogin = () => {
  router.push({
    name: ''
  });
}
router.afterEach((to, from, next) => {
  if (to.meta.scrollTop) {
    window.scrollTo(0, 0)
  }
})


Vue.prototype.$api = api;
/* eslint-disable no-new */




new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js